/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/pages/dashboards/Dashboard.js";
import Login from "views/pages/main/Login.js";
import Settings from "views/pages/main/Settings.js";
import Register from "views/pages/main/Register.js";
import ChecklistsCalendar from "views/pages/main/ChecklistsCalendar.js";
import Checklists from "views/pages/tables/Checklists.js";
import Billing from "views/pages/main/Billing.js";
import User from "views/pages/main/User.js";
import Welcome from "views/pages/main/Welcome.js";
import Feedback from "views/pages/main/Feedback";
import PrivacyPolicy from "views/pages/main/PrivacyPolicy";

const routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-red",
    component: Dashboard,
    layout: "/admin",
  },
  {
    path: "/checklists",
    name: "Checklists",
    icon: "ni ni-bullet-list-67 text-red",
    component: Checklists,
    layout: "/admin",
  },
  {
    path: "/checklists-calendar",
    name: "Checklists Calendar",
    icon: "ni ni-calendar-grid-58 text-red",
    component: ChecklistsCalendar,
    layout: "/admin",
  },
  {
    path: "/billing",
    name: "Billing",
    icon: "ni ni-money-coins text-red",
    component: Billing,
    layout: "/admin",
  },
  {
    path: "/setting",
    name: "Settings",
    icon: "ni ni-settings-gear-65 text-red",
    component: Settings,
    layout: "/admin",
  },
  {
    path: "/user",
    name: "User",
    miniName: "U",
    component: User,
    layout: "/admin",
    redirect: true,
  },
  {
    path: "/login",
    name: "Login",
    miniName: "L",
    component: Login,
    layout: "/auth",
    redirect: true,
  },
  {
    path: "/register",
    name: "Register",
    miniName: "R",
    component: Register,
    layout: "/auth",
    redirect: true,
  },
  {
    path: "/welcome",
    name: "Welcome",
    miniName: "W",
    component: Welcome,
    layout: "/auth",
    redirect: true,
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    miniName: "PP",
    component: PrivacyPolicy,
    layout: "/auth",
    redirect: true,
  },
  {
    path: "/feedback",
    name: "Feedback",
    miniName: "F",
    component: Feedback,
    layout: "/auth",
    redirect: true,
  },
];

export default routes;
